const endeavorConfig = window.appState.endeavorConfig;
export const REACT_APP_ENDEAVOR_X_API_KEY = endeavorConfig ? endeavorConfig.apiKey : '81a42cb0-6b8f-4d93-9419-78d3660f2f8f';
export const REACT_APP_ENDEAVOR_REALM = endeavorConfig ? endeavorConfig.realm : 'dce.oneclub';
export const REACT_APP_ENDEAVOR_BASE_URL = endeavorConfig ? endeavorConfig.baseUrl : 'https://dce-frontoffice.imggaming.com';

export const ENDEAVOR_AUTH = 'endeavor-auth';
export const GRANTED = 'GRANTED';
export const GRANTED_ON_SIGN_IN = 'GRANTED_ON_SIGN_IN';
export const DENIED = 'DENIED';

export const GRANT_TYPE = 'grant_type';
export const SUBJECT_TOKEN_TYPE = 'subject_token_type';
export const SUBJECT_TOKEN = 'subject_token';

export const TAGGED_VIDEOS_URL = `${REACT_APP_ENDEAVOR_BASE_URL}/api/v4/tagged/vod`;
